import React from 'react';
import { Typography, Modal, Button, Box } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { makeStyles } from '@material-ui/core/styles';
import { DetailsEditComponent } from './EditComponent';

const useStyles = makeStyles((theme) => ({
  detailsBox: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    backgroundColor: theme.palette.background.default,
    border: '2px solid #000',
    borderRadius: '20px',
    padding: '20px',
    boxShadow: 24,
  },
}));

const ViewComponent = (props) => {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();

  return (
    <td style={{ textAlign: 'right' }}>
      <Button onClick={() => setOpen(true)} style={{ padding: '6px 16px' }}>
        <VisibilityIcon />
      </Button>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="view-modal-title"
        aria-describedby="view-modal-description"
      >
        <Box className={classes.detailsBox} style={{ maxHeight: '100vh', overflowY: 'auto' }}>
          <DetailsEditComponent
            rowData={{ ...props.rowData, id: '' }}
            detail_get_url={props.detail_get_url}
            non_editable_fields={props.view_fields}
            editable_fields={[]}
          />
        </Box>
      </Modal>
    </td>
  );
};

export default ViewComponent;